'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/steps/style/css.js
// module id = 582
// module chunks = 0